import { Dimensions } from '../types/dimensions.js';

export function getDraggableBounds(
  toolbarSize: Dimensions,
  boundSize: Dimensions,
) {
  const { width: elementWidth, height: elementHeight } = toolbarSize;
  const { width: boundaryWidth, height: boundaryHeight } = boundSize;

  const maxRightBoundary = boundaryWidth - elementWidth;
  const maxTopBoundary = boundaryHeight - elementHeight;

  return {
    right: maxRightBoundary,
    top: maxTopBoundary,
  };
}
